import type { TypographyOptions } from '@mui/material/styles/createTypography';
import { pxToRem, responsiveFontSizes } from '../utils/getFontValue';

// ----------------------------------------------------------------------
// Expressive headings, readable body text and compact supporting labels.
// ----------------------------------------------------------------------

const FONT_PRIMARY = 'Inter, -apple-system, Segoe UI, Roboto, sans-serif';
const FONT_HEADING = 'Epilogue, Inter, sans-serif';

const typography: TypographyOptions = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: FONT_HEADING,
    fontWeight: 700,
    lineHeight: 1.2,
    fontSize: pxToRem(30),
    letterSpacing: '-0.02em',
    ...responsiveFontSizes({ sm: 38, md: 44, lg: 48 }),
  },
  h2: {
    fontFamily: FONT_HEADING,
    fontWeight: 700,
    lineHeight: 1.25,
    fontSize: pxToRem(24),
    letterSpacing: '-0.015em',
    ...responsiveFontSizes({ sm: 28, md: 34, lg: 36 }),
  },
  h3: {
    fontFamily: FONT_HEADING,
    fontWeight: 700,
    lineHeight: 1.3,
    fontSize: pxToRem(20),
    letterSpacing: '-0.01em',
    ...responsiveFontSizes({ sm: 24, md: 28, lg: 30 }),
  },
  h4: {
    fontFamily: FONT_HEADING,
    fontWeight: 700,
    lineHeight: 1.35,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 21 }),
  },
  h5: {
    fontFamily: FONT_HEADING,
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(16),
    ...responsiveFontSizes({ sm: 17, md: 17, lg: 18 }),
  },
  h6: {
    fontFamily: FONT_HEADING,
    fontWeight: 600,
    lineHeight: 1.45,
    fontSize: pxToRem(15),
    ...responsiveFontSizes({ sm: 16, md: 16, lg: 16 }),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.45,
    fontSize: pxToRem(15),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 1.45,
    fontSize: pxToRem(13),
  },
  body1: {
    lineHeight: 1.7,
    fontSize: pxToRem(16),
  },
  body2: {
    lineHeight: 1.65,
    fontSize: pxToRem(14),
  },
  caption: {
    lineHeight: 1.45,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.45,
    fontSize: pxToRem(11),
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 600,
    lineHeight: 1.6,
    fontSize: pxToRem(14),
    textTransform: 'none',
  },
};

export default typography;
